<template lang="pug">
  .operator-table__table.scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content
                a.toggle(
                v-if="item.houses.length > 0"
                @click.prevent="toggleRow($event)"
                ) {{item.name}}
                .table__cell-content(
                  v-else
                ) {{item.name}}
            td.table__cell
              .table__cell-content {{item.type}}
            td.table__cell
              .table__cell-content {{item.capacity}}
            td.table__cell
              .table__cell-content {{item.director_fio}}
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right
                .form-switch.form-switch_small.form-switch_transparent.table__cell-control
                  label.form-switch__label
                    input.form-switch__input(
                    type="checkbox"
                    v-model="item.is_published"
                    @click.prevent="switchChange(item)"
                    )
                    .form-switch__outline
                    .form-switch__switch
                router-link.button.button_square.table__cell-control(
                :to="{name: 'AdminCampEditor', params: { id: item.id }}"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
                button.button.button_square.table__cell-control(
                @click.prevent="onDeleteCamp(item)"
                )
                  img(src="@/assets/images/icons/trash.svg")
          //tr.table__row.is-open
          tr.is-opened(
          v-if="item.houses.length > 0"
          )
            td(colspan="5").is-opened__content
              table.table-inner
                thead
                  tr.table__row
                    th.table__cell
                      .table__cell-content Корпус
                    th.table__cell
                      .table__cell-content Вместимость
                tbody.table__body
                  tr.table__row(
                  v-for="house in item.houses"
                  )
                    td.table__cell
                      .table__cell-content {{house.name}}
                    td.table__cell
                      .table__cell-content {{house.capacity}}
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "CampScrollFixTable",
  props: [
    "tab-data",
    "tab-head"
  ],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  },
  methods: {
    toggleRow(e) {
      e.target.closest("tr").classList.toggle("is-open");
    },
    onDeleteCamp(camp) {
      this.$emit("on-delete-camp", camp);
    },
    switchChange(item) {
      this.$emit("switch-change", item);
    }
  },
  mounted() {

  }
};
</script>
